module.exports = __webpack_public_path__ + "static/img/img-advantage2.cc2d73f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-advantage2.svg
// module id = 0y0v
// module chunks = 0